export const CURRENCY_MAP: Record<string, string> = {
  /*
   * Changed from symbols to abbreviations to match backend provided formatted
   * price.
   */
  USDT: 'USDT',
  AMD: '֏',
  FTN: 'FTN',
  DOGE: 'DOG',
  XRP: 'XRP',
  BTC: 'BTC',
  ETH: 'ETH',
  AED: 'AED',
  USD: '$',
  CNY: 'CN¥',
  INR: '₹',
  EUR: 'EUR'
};

export const CURRENCIES: Record<
  string,
  {
    symbol: string;
    name: string;
    fractionalDigits: number;
  }
> = {
  USDT: {
    symbol: '₮',
    name: 'USDT',
    fractionalDigits: 2
  },
  AMD: {
    symbol: '֏',
    name: 'AMD',
    fractionalDigits: 0
  },
  FTN: {
    symbol: 'FTN',
    name: 'FTN',
    fractionalDigits: 2
  },
  DOGE: {
    symbol: 'DOG',
    name: 'DOGE',
    fractionalDigits: 2
  },
  XRP: {
    symbol: 'XRP',
    name: 'XRP',
    fractionalDigits: 2
  },
  BTC: {
    symbol: 'BTC',
    name: 'BTC',
    fractionalDigits: 8
  },
  ETH: {
    symbol: 'ETH',
    name: 'ETH',
    fractionalDigits: 8
  },
  AED: {
    symbol: 'AED',
    name: 'AED',
    fractionalDigits: 2
  },
  USD: {
    symbol: '$',
    name: 'USD',
    fractionalDigits: 2
  },
  CNY: {
    symbol: 'CN¥',
    name: 'CNY',
    fractionalDigits: 2
  },
  INR: {
    symbol: '₹',
    name: 'INR',
    fractionalDigits: 2
  },
  EUR: {
    symbol: 'EUR',
    name: 'EUR',
    fractionalDigits: 2
  }
};
